import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setSelectedPlan } from './OrganizationPortalSlice';
import Popup from '../../Shared/Popup/PopUp';
import ProductDetailsPopUp from './PopUp/ProductDetailsPopUp';
import OrgFooterButtons from './OrgFooterButtons';
import { productStatus } from '../SelfCareProductsAndServicesBlock/productsAndServicesBlockSlice';
import { color } from 'd3';

function OrgProductSelection({ products, selectedPlan, setSelectedPlan, userDetails }) {
  const [product, setProduct] = useState();
  const [error, setError] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const isUpdateAction = userDetails.ban != '';

  useEffect(() => {
    if (isUpdateAction && userDetails.phoneModelId != '' && !selectedPlan.model.itemId) {
      var selectedProduct = products.filter((p) => p.models.find((m) => m.itemId == userDetails.phoneModelId))?.[0];
      if (selectedProduct) {
        setSelectedPlan({
          ...selectedPlan,
          model:
          {
            name: selectedProduct.modelName,
            price: selectedProduct.price,
            storage: selectedProduct.storage,
            itemId: userDetails.phoneModelId,
            color: selectedProduct.models.filter(m => m.itemId == userDetails.phoneModelId)[0]?.color
          }
        });
      }
    }
  }, []);

  const goToNextPage = () => {
    if (!Object.keys(selectedPlan.model).length) {
      setError('אנא בחר מוצר');
      return false;
    }
    if (userDetails.actionType === 'upgrade' && userDetails.isReturningOldDevice === null) {
      setError('בחרו אם מכשיר המקורי יוחזר לארגון');
      return false;
    }
    setError('');
    return true;
  }

  return (
    <div className='Org_Products step-page_M'>
      <div className='M_Title'> מגוון ענק של מכשירים במחירים מיוחדים רק בשבילך</div>
      <div className='M_SubTitle'>   בחרו מכשיר לקבלת מידע וביצוע פעולות</div>
      <div className='products-container'>
        {products.map((p, index) => {
          const currentSelection = p.models.find((m) => m.itemId == (selectedPlan.model?.itemId ?? ''));
          return (
            <div
              onClick={() => {
                setShowDetails(true);
                setProduct(p)
              }}
              className={`product ${currentSelection ? 'selectedProduct' : ''}`}
              key={index}>
              <div className="model">
                <span className='name'>{p.modelName}</span>
                <span className='storage'>{p.storage + 'GB'}</span>
              </div>
              {p.price > 0 ?
                <span className='price'>&#8362;{p.price}</span>
                :
                <span className='price'>ללא עלות</span>
              }
            </div>
          );
        })}
      </div>
      <OrgFooterButtons onContinue={() => goToNextPage()} error={error} />
      <Popup className="OrganizationPopup product" showPopUp={showDetails} onClose={() => setShowDetails(false)}>
        <ProductDetailsPopUp product={product} setShowPopup={setShowDetails} setProduct={setProduct} setError={setError} />
      </Popup>
    </div>
  );
}

const mapStateToProps = (state) => ({
  selectedPlan: state.organizationPortal.userDetails.selectedPlan,
  currentStep: state.organizationPortal.steps.current,
  products: state.organizationPortal.products,
  userDetails: state.organizationPortal.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgProductSelection);
